import { cn } from '@/lib/utils';

// `level` de GET [admin/]user_learning_paths/:id/performance → cor da barra.
// A API já classifica (good ≥ 66%, regular ≥ 33%); `insufficient_data` (< 5 questões)
// e `not_started` (descritor sem aula gerada) ficam em cinza, sem cor de desempenho.
const LEVEL_COLOR = {
  good: 'bg-success',
  regular: 'bg-warning',
  needs_improvement: 'bg-danger'
};

const LEVEL_LABEL = {
  insufficient_data: 'Sem dados suficientes',
  not_started: 'Não iniciado'
};

export function PerformanceBar({ percentage, level, compact = false, className }) {
  const label = LEVEL_LABEL[level];
  const clamped = Math.min(100, Math.max(0, percentage ?? 0));
  return (
    <div className={cn('flex items-center gap-2', compact ? 'w-24 shrink-0' : 'w-full', className)}>
      <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-neutral-lightest">
        <div
          className={cn('h-full rounded-full', LEVEL_COLOR[level] || 'bg-neutral-light')}
          style={{ width: `${clamped}%` }}
        />
      </div>
      <span
        className="shrink-0 text-xs text-neutral-dark"
        title={label}
      >
        {clamped.toLocaleString('pt-BR', { maximumFractionDigits: 20 })}%
      </span>
    </div>
  );
}
